import * as React from "react";
import {Icon} from "../../hiberUiKit/src/atoms/Icon/Icon";
import IconLarge from "../../hiberUiKit/src/atoms/Icon/IconLarge";

export enum RotateType {
	ClockWise,
	CounterClockWise
}

interface Props {
	/**
	 * Rotation direction
	 */
	direction: RotateType;
	/**
	 * Rotate button click callback
	 */
	onClick: (direction: RotateType) => void;
}

export class AttachmentImageRotateButton extends React.Component<Props> {
	render() {
		return (
			<span style={{paddingRight: '15px'}}>
				<IconLarge icon={Icon.Reset}
						   variant={'white'}
						   onClick={() => this.props.onClick(this.props.direction)}
						   transform={this.props.direction === RotateType.ClockWise ? 'scale(-1, 1)' : ''}/>
            </span>
		)
	}
}